export default "/assets/images/current-room-status.4338beb709d6b542.mp4";